var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.90614 0.25C2.32684 0.25 0.25 2.32684 0.25 4.90614V21.0938C0.25 23.6731 2.32684 25.75 4.90614 25.75H13.6797V15.7811H11.0437V12.192H13.6797V9.12559C13.6797 6.71648 15.2372 4.50451 18.8251 4.50451C20.2778 4.50451 21.352 4.64397 21.352 4.64397L21.2675 7.99564C21.2675 7.99564 20.172 7.98528 18.9765 7.98528C17.6827 7.98528 17.4752 8.58142 17.4752 9.57107V12.192H21.3703L21.2006 15.7811H17.4752V25.75H21.0938C23.6731 25.75 25.7499 23.6732 25.7499 21.0939V4.90616C25.7499 2.32687 23.6731 0.250025 21.0938 0.250025H4.90611L4.90614 0.25Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
